

import { useState, createContext, useContext } from 'react'
/**
 * QueryRequestProvider & useQueryRequest
 *
 * Provides React context and hooks for managing and updating query request state in the application.
 *
 * Features:
 * - Stores pagination, order, and document type in state
 * - Allows updating query state via context
 * - Used for global state management in data fetching components
 *
 * Exports:
 * - QueryRequestProvider: Context provider component
 * - useQueryRequest: Hook to access and update query request state
 * - initialQueryRequest: Initial state object
 */
const initialQueryRequest = {
    state: {
        page: 1,
        items_per_page: 10,
        order: 'desc',
        document: 'all'
    },
    updateState: () => { },
}
const QueryRequestContext = createContext(initialQueryRequest)

const QueryRequestProvider = ({ children }) => {
    const [state, setState] = useState(initialQueryRequest.state)

    const updateState = (updates) => {
        const updatedState = { ...state, ...updates }
        setState(updatedState)
    }

    return (
        <QueryRequestContext.Provider value={{ state, updateState }}>
            {children}
        </QueryRequestContext.Provider>
    )
}

const useQueryRequest = () => useContext(QueryRequestContext)
export { QueryRequestProvider, useQueryRequest, initialQueryRequest }
